import React from 'react';

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

// auth
import { useAuth } from 'contexts/AuthContext';

// components
import DashboardEmbed from 'components/dashboards/DashboardEmbed';

function MainMenu() {
  const { user } = useAuth();
  const displayName = (user && (user.name || user.preferred_username || user.email)) || 'User';

  return (
    <Container className="mt-4 h-auto" fluid>
      <Row className="justify-content-center">
        <Col xs="12" lg="11" xl="12">
          <Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
              <h3 className="mb-0 text-primary">Welcome, {displayName}</h3>
            </CardHeader>
            <CardBody>
              <Row className="justify-content-center">
                <Col xs="12" className="mb-4">
                  <Card className="card-stats shadow-sm border-0">
                    <CardBody className="p-0">
                      <DashboardEmbed 
                        dashboardName="initial_dashboard"
                        title="AWS QuickSight Dashboard"
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default MainMenu;
